// React Imports
import * as React from 'react';
import {  useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import {Avatar, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tooltip} from "@mui/material";
import {Check, CheckBox, CheckCircleOutline} from "@mui/icons-material";
import {deepOrange, lightGreen} from "@mui/material/colors";
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import DeleteIcon from '@mui/icons-material/Delete';

// App Imports
import {
    deleteContractDataPointValue,
    getCDPVbyCDPid
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {changeContractDataPointValue} from "../../ContractDataPointValue/contractDataPointValueSlice";
import {changeContractDrilldownCDPV} from "./contractDrilldownSliceCDPV";
import Button from "@mui/material/Button";
import {changeContractDrilldownCDP} from "../ContractDrilldownCDP/contractDrilldownSliceCDP";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import {changeObligationHierarchy} from "../../WorkIssuance/WorkIssuanceObligation/obligationHierarchySlice";


// main function
export default function CDPVGrid(props) {

    // ****************** BEGINf STATES ****************************

    const [showCDPVGrid, setShowCDPVGrid] = React.useState(false);
    const [contractDataPointValues, setContractDataPointValues] = useState([]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpvDrawerMode = useSelector((state) => state.contractDataPointValueSlc.value.cdpvDrawerMode);
    const selectorCdpvId = useSelector((state) => state.contractDataPointValueSlc.value.id);
    const selectorCdpDataPointName = useSelector((state) => state.contractDataPointSlc.value.dataPointName);
    const selectorCDPid = useSelector((state) => state.contractDrilldownSlcCDP.value.id);
    const selectorFilterid = useSelector((state) => state.contractDrilldownSlcCDP.value.filterId);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractDataPointValues = () =>{
        getCDPVbyCDPid(selectorCDPid)

            .then(data => {
                console.log("my cdpv grid data that has been generated");
                console.log(data);
                if(selectorFilterid <1 || selectorFilterid === null || selectorFilterid === undefined ){
                    console.log("no filter selected");
                setContractDataPointValues(data);}
                if(selectorFilterid >0){
                    console.log("filter id  = ", selectorFilterid);
                    setContractDataPointValues(data.filter(data => data.contractDataPointValueFilterId ===  selectorFilterid));}
            })
    };

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchContractDataPointValues();
    }, [useSelector((state) => state.contractDrilldownSlcCDPV.value.cdpvGridState)===true]);


    useEffect(() => {
        fetchContractDataPointValues();
        dispatchData(changeContractDrilldownCDPV({cdpvGridRefresh: false}));
    }, [useSelector((state) => state.contractDrilldownSlcCDPV.value.cdpvGridRefresh)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleEdit = (rowFull) => {
        dispatchData(changeContractDataPointValue({id: rowFull.id, contractDataPointId: rowFull.contractDataPointId,
            ordinalNumber: rowFull.ordinalNumber, iterationNumber: rowFull.iterationNumber,
            extendInd: rowFull.extendInd, value: rowFull.value,  expression: rowFull.expression, expressionDescription: rowFull.expressionDescription,
            expressionTranslation: rowFull.expressionTranslation,
            sourceContractDataPointValueId: rowFull.sourceContractDataPointValueId, origin: rowFull.origin,
            status: rowFull.status, mockValue: rowFull.mockValue, contractDataPointValueFilterId: rowFull.contractDataPointValueFilterId,
            createdOn: rowFull.createdOn, createdBy: rowFull.createdBy, lastModifiedOn: rowFull.lastModifiedOn, lastModifiedBy: rowFull.lastModifiedBy,
            cdpvGridState: false, cdpvDrawerState: true, cdpvDrawerContext: "cdpGrid", cdpvDrawerMode: "Edit"}));
        console.log("Here's the selected row data to edit from drilldown");
        console.log(rowFull);
    }

    // ==== begin CDPD delete

    // const handleDeleteCdp = () => {
    //     console.log("deleting this contract data point id");
    //     console.log(selectorContractDataPointId);
    //     deleteContractCDP(selectorContractDataPointId).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         orderCDPinCS(selectorContractSectionId)).then(
    //         dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    // };

    const [confirmSingleCdpvDeleteOpen, setConfirmSingleCdpvDeleteOpen] = React.useState(false);

    const handleConfirmSingleCdpvDeleteClose = () => setConfirmSingleCdpvDeleteOpen(false);

    const handleDelete = (rowFull) => {
        dispatchData(changeContractDataPointValue({id: rowFull.id}));
        console.log("Here's the selected row data to edit from drilldown");
        console.log(rowFull);
        setConfirmSingleCdpvDeleteOpen(true);
        // setAnchorEl(null);
    }

    // const handleDeleteCdpv = () => {
    //         setConfirmSingleCdpvDeleteOpen(true);
    //         setAnchorEl(null);
    //  };


    const handleConfirmSingleCdpvDelete = () => {
        console.log("deleting this contract data point value id");
        console.log(selectorCdpvId);
        deleteContractDataPointValue(selectorCdpvId).then(
            // orderCDPinCS(selectorContractSectionId)).then(
            // orderCDPinCS(selectorContractSectionId)).then(
            dispatchData(changeContractDrilldownCDPV({cdpvGridRefresh: true})))
            .then(() => {
                setConfirmSingleCdpvDeleteOpen(false);
            });
        // console.log("contract to be deleted = ", selectorContractId2);
        // setConfirmOpen(false);
    };

    // ==== end CDPD delete


    function closeCDPVGridDrawer() {
        setShowCDPVGrid(false);
        dispatchData(changeContractDrilldownCDPV({cdpvGridState: false}));
        console.log("closing the drawer");
        console.log("show set drawer");
        console.log({setShowCDPVGrid});
        console.log("show drawer");
        console.log({showCDPVGrid});
    };



    const handleExploreExternalData = (selectedCDPV) => {
//        setShowCdpvGrid(!showCdpvGrid);
        console.log("Here's the row data from clicking the external data button");
        console.log(selectedCDPV);
        console.log("Here's the cdpvId: ", selectedCDPV.id);
        console.log(selectedCDPV);
        // getCDPVbyCDPid(selectedCDPV)
        //
        //     .then(() => {
        dispatchData(changeObligationHierarchy({cdpvId: selectedCDPV.id
            ,  externalSource: selectedCDPV.externalSource, displayValue: selectedCDPV.mockValue,
            dataPointName: selectedCDPV.dataPointName,contractName: selectedCDPV.contractName,
            reuseMarket: selectedCDPV.reuseMarket,  dataType: selectedCDPV.dataType
        }));
        // alert(selectedCDPV.externalSource);
        if(selectedCDPV.externalSource === 'financial')
        {        console.log("financial grid triggered")
            // setOpenFinancialDrawer(true);
            dispatchData(changeObligationHierarchy({financialGridOpen: true}))};
        if(selectedCDPV.externalSource === 'usage')
        {dispatchData(changeObligationHierarchy({usageGridOpen: true}))};
        if(selectedCDPV.externalSource === 'license')
        {dispatchData(changeObligationHierarchy({licenseGridOpen: true}))};
        if(selectedCDPV.externalSource === 'platform')
        {dispatchData(changeObligationHierarchy({platformGridOpen: true}))};
        if(selectedCDPV.externalSource === 'viewership')
        {dispatchData(changeObligationHierarchy({viewershipGridOpen: true}))};
        if(selectedCDPV.externalSource === 'product')
        {dispatchData(changeObligationHierarchy({productGridOpen: true}))};
        if(selectedCDPV.externalSource === 'subscriber')
        {dispatchData(changeObligationHierarchy({subscriberGridOpen: true}))};
        if(selectedCDPV.externalSource === 'cast_list')
        {dispatchData(changeObligationHierarchy({stakeholderListGridOpen: true}))};
    };
    // )};

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = (fetchContractDataPointValues) => [
        {
            field: "dataPointValueEdit",
            headerName: '',
            onCellClick: {},
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: selectorCdpvDrawerMode !== "Edit",
            renderCell: (dataPointValues) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <EditIcon fontSize={'small'}  onClick= {() => handleEdit(dataPointValues.row)}/>
                    </IconButton>
                );
            }
        },
        {
            field: "dataPointValueDelete",
            headerName: '',
            onCellClick: {},
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: selectorCdpvDrawerMode !== "Delete",
            renderCell: (dataPointValues) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <DeleteIcon fontSize={'small'} color="error" onClick= {() => handleDelete(dataPointValues.row)}/>
                    </IconButton>
                );
            }
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 100,
            hide: true,
        },
        {
            field: 'cycleNumber',
            headerName: 'Cycle',
            description: '',
            sortable: true,
            // editable: true,
            width: 60,
        },
        {
            field: 'ordinalNumber',
            headerName: 'Order',
            description: '',
            sortable: true,
            // editable: true,
            width: 60,
        },
        {
            field: 'iterationNumber',
            headerName: 'Iteration',
            description: '',
            sortable: true,
            // editable: true,
            width: 90,
        },
        {
            field: 'mockValue',
            headerName: 'Value',
            description: '',
            sortable: true,
            // editable: true,
            width: 300,
        },
        {
            field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
            headerName: 'Exp',
            renderCell: (dataPointValues) =>
            {
                if((dataPointValues.row.expression !== null) && (dataPointValues.row.expression !== '')){
                    return (
                        <Tooltip   enterDelay={1000}  title={"Value comes from an expression.  Click to see."}>
                            <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                            {/*<Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>{filteredCDP.row.mockIndicator} </Avatar>*/}
                        </Tooltip>)}
            },
            description: '',
            sortable: false,
            width: 50,
        },
        {
            field:  'extendInd',
            headerName: 'Extend',
            renderCell: (dataPointValues) =>
            {
                if(dataPointValues.row.extendInd === true ){
                    return (
                        <Tooltip title={"Data Point Value is flagged to extend."}>
                            <Check/>
                        </Tooltip>)}

                if(dataPointValues.row.extendInd === false ){
                    return (
                        <p/>
                    )}
            },
            description: '',
            sortable: false,
            width: 100,
        },
        // {
        //     field: 'extendInd',
        //     headerName: 'Extend',
        //     formatter: CheckBox,
        // },
        {
            field: 'externalData',
            headerName: 'External Data',
            description: '',
            sortable: false,
            width: 100,
            renderCell: (dataPointValues) => {
                if (dataPointValues.row.externalDataCount > 0) {
                    return (
                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                            <Tooltip
                                enterDelay={1000}
                                title={"Data comes from external source. Click to see details."}
                            >
                                <Avatar
                                    onClick={() => handleExploreExternalData(dataPointValues.row)}
                                    sx={{
                                        height: 20,
                                        width: 20,
                                        fontSize: 16,
                                        bgcolor: lightGreen[500],
                                        cursor: 'pointer'
                                    }}
                                >
                                    d
                                </Avatar>
                            </Tooltip>

                            {/*{workQueueCDP.row.adjustedInd === true && (*/}
                            {/*    <Tooltip*/}
                            {/*        enterDelay={1000}*/}
                            {/*        title={"Adjustment(s)"}*/}
                            {/*    >*/}
                            {/*        <Box*/}
                            {/*            sx={{*/}
                            {/*                position: 'absolute',*/}
                            {/*                top: -3,*/}
                            {/*                right: -8,*/}
                            {/*                height: 12,*/}
                            {/*                width: 12,*/}
                            {/*                minWidth: 12,*/}
                            {/*                borderRadius: '50%',*/}
                            {/*                backgroundColor: 'black',*/}
                            {/*                color: 'white',*/}
                            {/*                fontSize: 12,*/}
                            {/*                display: 'flex',*/}
                            {/*                alignItems: 'center',*/}
                            {/*                justifyContent: 'center',*/}
                            {/*                lineHeight: 1,*/}
                            {/*                cursor: 'pointer'*/}
                            {/*            }}*/}
                            {/*            onClick={(e) => e.stopPropagation()}*/}
                            {/*        >*/}
                            {/*            a*/}
                            {/*        </Box>*/}
                            {/*    </Tooltip>*/}
                            {/*)}*/}
                        </Box>
                    );
                }
                return null;
            },
        },
        {
            field: 'expression',
            headerName: 'expressionTranslation',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'rawExpression',
            headerName: 'rawExpression',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'createdOn',
            headerName: 'createdOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'createdBy',
            headerName: 'createdBy',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedOn',
            headerName: 'lastModifiedOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedBy',
            headerName: 'lastModifiedBy',
            description: '',
            width: 100,
            hide: true
        },
    ];

    // ****************** END COLUMNS ****************************




    function DetailPanelContent() {
        return (
            <h2>TEST</h2>
            // <div>{id}</div>
        )}

    const getDetailPanelHeight = React.useCallback(() => 300, []);


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer sx={{height: "100%", width: 800}}
                anchor='right'

            open={useSelector((state) => state.contractDrilldownSlcCDPV.value.cdpvGridState) }

                onClose={closeCDPVGridDrawer}
            >
                <Box                 sx={{height: 800, width: 800}}>

                    <h2 style={ { paddingLeft: 15, cursor: 'pointer' }} onClick={() => closeCDPVGridDrawer()}>Contract Data Point Value Grid</h2>
                    <Typography  sx={{ fontWeight: 'bold'
                    }}
                                 style={ { paddingLeft: 15,
                                 }}>{selectorCdpDataPointName}</Typography>
                    {/*<br/>*/}
                    <h4 style={ { paddingLeft: 15 }}>{selectorCdpvDrawerMode} Mode</h4>
                <br/>

                    <Dialog open={confirmSingleCdpvDeleteOpen} onClose={handleConfirmSingleCdpvDeleteClose}>
                        <DialogTitle>Confirm Contract Data Point Value Delete</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Are you sure you want to delete this Contract Data Point Value? This action cannot be undone.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleConfirmSingleCdpvDeleteClose} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={handleConfirmSingleCdpvDelete} color="error">
                                Delete
                            </Button>
                        </DialogActions>
                    </Dialog>
                {useSelector((state) => state.contractDrilldownSlcCDPV.value.cdpvGridState)  &&
                <DataGridPro

                    initialState={{
                    }}
                    aria-label={"ContractDataPointValues"}
                    rows={contractDataPointValues}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(fetchContractDataPointValues)}
                    getDetailPanelHeight={getDetailPanelHeight}
                    getDetailPanelContent={({ row }) => (
                        <Box sx={{ p: 2,
                            bgcolor: deepOrange[100]
                        }}>
                            {`Expression: ${row.expression}`}
                            <br/>
                            <br/>
                            {`Translation: ${row.expressionTranslation}`}
                            <br/>
                            <br/>
                            {`Raw Expression: ${row.rawExpression}`}
                        </Box>
                    )}
                    density={"compact"}
                    style={ { paddingLeft: 15 }}
                    pageSize={30}
                    rowKey={contractDataPointValue => contractDataPointValue.id}
                />}
                </Box>

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
